import AudioRecorder from './AudioRecorder';

export default AudioRecorder;
